import { render, staticRenderFns } from "./ProductSideSheetSpreadDetails.vue?vue&type=template&id=2d9c9bac&scoped=true"
import script from "./ProductSideSheetSpreadDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSideSheetSpreadDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSideSheetSpreadDetails.vue?vue&type=style&index=0&id=2d9c9bac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c9bac",
  null
  
)

export default component.exports